import axios from 'axios'
import QS from 'qs'

// axios.defaults.baseURL = 'https://azhycms.meldingcloud.com/'

export function get(url, params = {}, context) { //context vue 实例
    return new Promise((resolve, reject) => {
        url += "?timestamp="+new Date().getTime(); //加了个时间戳
        url = encodeURI(url);//对url 进行编码
        axios.get(url).then(res => {
            if (res.status === 200) { //http 请求成功
                resolve(res);
            } else {
                reject({
                    errorMsg: res.statusText
                })
            }
        }).catch(err => {
            console.log('没有了')
            reject(err)
        })
    })
}

export function get2(url, params = {}, context) { //context vue 实例
    return new Promise((resolve, reject) => {
        url += "&timestamp="+new Date().getTime(); //加了个时间戳
        axios.get(url).then(res => {
            if (res.status === 200) { //http 请求成功
                resolve(res);
            } else {
                reject({
                    errorMsg: res.statusText
                })
            }
        }).catch(err => {
            console.log('没有了')
            reject(err)
        })
    })
}

export function post(url, params = {}, context) {
    return new Promise((resolve, reject) => {
        axios.post(url, QS.stringify(params)).then(res => { //序列化字符串
            if (res.status === 200) { 
                resolve(res);
            } else {
                reject({
                    errorMsg: res.statusText
                })
            }
        }).catch(err => {
            reject(err)
        })
    })
}


// WEBPACK FOOTER //
// ./src/api/api.js